<template>
  <Transition name="slide-fade">
    <div v-if="drawer && getCurrentProyectState !== ''" class="layoutV">
      <ASideProjectMainMenu :state="getCurrentProyectState" :projectId="projectId" :key="componentKey" @refresh="forceRerender" />
    </div>
  </Transition>
</template>

<script>
import { useStore } from "vuex";
import { defineComponent, computed, watch, ref, onBeforeUnmount } from "vue";
import ASideProjectMainMenu from "../components/ASideProjectMainMenu.vue";
import { useRoute } from "vue-router";
import { sleep } from "@/utils";

export default defineComponent({
  components: {
    ASideProjectMainMenu,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const projectId = ref("");
    const drawer = ref(false);
    const componentKey = ref(0);
    const isLoading = ref(false);

    const getCurrentProyectState = computed(() => {
      return store.state.currentState;
    });


    // TODO se debe ejecutar esta función de nuevo ** para que habilite las opciones de menú
    // execució, JT y JE
    const getCurrentState = async (projectId) => {
      // console.log("ejecuta getCurrentState: ", store);
      await store.dispatch("getProjectId", projectId);

    };

    watch(
      () => route.path,
      async () => {
        await sleep(500);
        if (route.path.includes("/projecte/memoria")) {
          drawer.value = true;
          const url = window.location.pathname;
          const ypid = url.match(/\/(?:.(?!\/))+$/);
          projectId.value = ypid[0] ? ypid[0]?.substring(1) : null;
          getCurrentState(projectId.value);

          forceRerender();
        } else if (!route.path.includes("/projecte")) {
          drawer.value = false;
          projectId.value = null;
        }
      }
    );

    const forceRerender = () => {
      componentKey.value += 1;
    };

    onBeforeUnmount(() => {
      console.log("ENTRA UNMOUNT");
      projectId.value = null;
      store.commit("RESET_STATE");
    });

    return { getCurrentProyectState, projectId, drawer, isLoading };
  },
});
</script>

<style>
.layoutV {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  margin-top: 52px;
  width: 153px;
  height: 100vh;
  position: fixed;
  top: 0;
  border-right: 1px solid #ccc;
  z-index: 1000;
}
.slide-fade-enter-active {
  transition: all 0.8s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
</style>
